import React from 'react'
import { TextInput } from 'oolib'

export const SearchBar = ({
  searchbarPlaceholder,
  searchBarFocus,
  searchString,
  setSearchString,
  setSearchBarFocus
}) => {
  return (
     <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1,
        padding: "4px 0",
        background: "white"
      }}
      onBlur={() => setSearchBarFocus(false)}
      tabIndex={0} //note: has to be camelcase to work
        >
          <div style={{ paddingBottom: "4px" }}>
            <TextInput
              placeholder={searchbarPlaceholder}
              forceFocus={searchBarFocus}
              type="text"
              icon="MagnifyingGlass"
              value={searchString}
              onChange={(k, v) => setSearchString(v)}
              S
            />
          </div>
    </div>
  )
}
